import React from 'react';
import { motion } from 'framer-motion';
interface Metric {
  label: string;
  value: string;
}
interface MetricsBarProps {
  metrics: Metric[];
}
export function MetricsBar({
  metrics
}: MetricsBarProps) {
  return <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8" data-id="element-512">
      {metrics.map((metric, index) => <motion.div key={index} initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.05
    }} className="bg-white p-4 rounded-xl shadow-sm border border-gray-200 hover:border-gray-400 transition-colors" data-id="element-513">
          <p className="text-xs text-gray-500 font-medium mb-1 uppercase tracking-wider" data-id="element-514">
            {metric.label}
          </p>
          <p className="text-lg font-bold text-gray-900 truncate" data-id="element-515">
            {metric.value}
          </p>
        </motion.div>)}
    </div>;
}